import React, { Component } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import {
  AppBar,
  Hidden,
  IconButton,
  Toolbar,
  Typography,
  SvgIcon
} from '@material-ui/core';
import { Menu as MenuIcon } from 'react-feather';
import Account from './Account';
import BLLogo from '../../../../../images/BlueMailAccount.png';
import BMLogo from '../../../../../images/type-white-100x100.svg';
import BPLogo from '../../../../../images/White-bplus_1.png';
import connect from "react-redux/es/connect/connect";

class TopBar extends Component{

  logout() {
    window.location.replace('/auth/logout')
  }

  getLogo(brandId) {
    switch (brandId) {
      case 'BL': {
        return BLLogo;
      }
      case 'BP': {
        return BPLogo;
      }
      default: {
        return BMLogo;
      }
    }
  }

  render(){
    let { onMobileNavOpen, user, brand } = this.props
    return (
      <AppBar style={{background: '#fff', zIndex: '1300', borderBottom: '1px solid', 
      borderImage: 'linear-gradient(90deg, rgba(27, 97, 237, 0.1) 12.5%, rgba(27, 97, 237, 0.1) 87.5%) 1 stretch', boxShadow: 'none'}}>
        <Toolbar style={{minHeight: '64px', justifyContent: 'space-between'}}>
          <Hidden lgUp>
            <IconButton
              onClick={onMobileNavOpen}
            >
              <SvgIcon fontSize="inherit">
                <MenuIcon />
              </SvgIcon>
            </IconButton>
          </Hidden>
          <Hidden mdDown>
              <div style={{display: 'flex', alignItems: 'flex-end'}}>
                <img src={this.getLogo(brand.id)} alt="brand-logo" style={{marginRight: '10px'}} />
              </div>
          </Hidden>

          <div style={{display: 'flex', alignItems: 'center'}}>
            <div style={{ fontWeight: 'bold', color: '#6F6F6F', fontSize: '15px' }}>{user.email}</div>
            <Account/>
          </div>
        </Toolbar>
      </AppBar>
    );
  }
}

const mapStateToProps = ({user, brand}) => ({user, brand});

export default connect(mapStateToProps)(TopBar);



// WEBPACK FOOTER //
// ./src/containers/app/components/DashboardLayout/TopBar/TopBar.js